(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/button-bet.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/button-bet.js');
"use strict";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const {
  useRef,
  useEffect
} = React;
const {
  ReactButtonBet: UiButtonBet
} = svs.ui;
const {
  wagerSystemTypes
} = svs.components.tipsen.engine.constants;
const systemsToNotShowDistribution = [wagerSystemTypes.RSYS, wagerSystemTypes.USYS];
const ButtonBet = _ref => {
  let {
    outcome,
    result,
    branding,
    isCorrect,
    systemType,
    uSign
  } = _ref;
  const buttonRef = useRef();
  const classNames = ['pg_coupon_static__bet_btn'];
  let isDistribution = false;
  isCorrect && classNames.push('btn-bet-result');
  const additionalProps = {};

  if (outcome && typeof outcome === 'number' && !systemsToNotShowDistribution.includes(systemType)) {
    additionalProps.title = "Systemf\xF6rdelning ".concat(outcome * 100, "%");
    additionalProps['data-outcome'] = result.text;
    classNames.push('pg_coupon_static__bet_btn--is-distribution');
    outcome < 0.5 && classNames.push('pg_coupon_static__bet_btn--is-low-distribution');
    isDistribution = true;
  }
  useEffect(() => {
    if (isDistribution) {
      buttonRef.current.style.setProperty('--distribution', "".concat(outcome * 100, "%"));
    }
  }, [isDistribution, outcome]);
  return React.createElement(UiButtonBet, _extends({
    branding: branding,
    className: classNames.join(' '),
    key: result.text,
    label: result.text,
    ref: buttonRef,
    selected: Boolean(outcome),
    size: "100"
  }, uSign ? {
    system: 'U'
  } : {}, additionalProps));
};
setGlobal('svs.components.tipsen.couponStatic.ButtonBet', ButtonBet);

 })(window);